import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

export interface UbicacionItem {
  project_id: string;
  project_nombre: string;
  project_codigo: string;
  en_proyecto: number;
  ultimo_movimiento: string;
}

export interface MovimientoDTO {
  id: string;
  equipo_id: string;
  project_id: string | null;
  tipo: string;
  cantidad: number;
  fecha: string;
  notas: string | null;
  created_at: string;
}

const movimientoKeys = {
  all: ['equipo-movimientos'] as const,
  list: (equipoId: string) => [...movimientoKeys.all, 'list', equipoId] as const,
};

export function useEquipoMovimientos(equipoId: string) {
  return useQuery({
    queryKey: movimientoKeys.list(equipoId),
    queryFn: async () => {
      const res = await api.get<{ data: MovimientoDTO[] }>(`/equipos/${equipoId}/movimientos`);
      return res.data.data;
    },
    enabled: !!equipoId,
  });
}

export function useEquipoUbicaciones(equipoId: string) {
  return useQuery({
    queryKey: ['equipo-ubicaciones', equipoId],
    queryFn: async () => {
      const res = await api.get<{ data: UbicacionItem[] }>(`/equipos/${equipoId}/ubicaciones`);
      return res.data.data;
    },
    enabled: !!equipoId,
  });
}

export function useCreateMovimiento(equipoId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { projectId?: string | null; tipo: string; cantidad: number; fecha: string; notas?: string | null }) => {
      const res = await api.post<{ data: MovimientoDTO }>(`/equipos/${equipoId}/movimientos`, data);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: movimientoKeys.list(equipoId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.equipos.all });
    },
  });
}
